import Communications from './communications.service';
import queryString from "query-string";
import {FormikErrors} from "formik";
import axios, {CancelTokenSource} from "axios";
import ApiService from './api.service';
import AlertService from "./alert.service";
import AccountService from "./modules/account.service";
import LocalStorageService from "./local-storage.service";
import {v4 as uuidv4} from 'uuid';
import UserService from "./modules/user.service";
import StaticDataService from "./modules/static-data.service";
import * as yup from "yup";
import {IConfirmationConfig} from "../models/confirmation.model";
import _ from "lodash";
import printJS from "print-js";
import {IAttachment} from "../models/common.model";
import AppointmentService from "./modules/appointment.service";
import RouteConfigService from "./route-config.service";
import ClientService from "./modules/client.service";
import BookAppointmentService from "./modules/book-appointment.service";
import CasesService from "./modules/cases.service";
import momentTimezone from "moment-timezone";
import moment from "moment-timezone";
import {Moment} from "moment";
import {TransactionService} from "./modules/transaction.service";
import DashboardService from "./modules/dashboard.service";

yup.addMethod(yup.mixed, 'atLeastOne', (args) => {
    const {message} = args;
    // @ts-ignore
    return this.test('atLeastOne', message, (list: any) => {
        // If there are 2+ elements after filtering, we know atMostOne must be false.
        return Object.keys(list).filter(item => item).length > 0
    })
});

const CurrentDate: Moment = moment();

const parseQueryString = (q: string): any => {
    return queryString.parse(q.replace('?', ''));
}

const getBytesInMB = (bytes: number) => {
    return bytes / (1024 * 1024);
}

const formatSizeUnits = (bytes: number, decimals = 2) => {
    if (bytes === 0) {
        return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const getRandomID = (length: number) => {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}

const getUUID = () => {
    return uuidv4();
}

const handleErrors = ((setErrors: (errors: FormikErrors<any>) => void, err: any, showGlobalError: boolean = false) => {
    if (err.errors) {
        const errors: any = {};
        for (let field in err.errors) {
            if (err.errors.hasOwnProperty(field)) {
                errors[field] = err.errors[field][0];
            }
        }
        setErrors(errors);
    }
    if (err.error) {
        AlertService.showToast(err.error);
    } else {
        if (showGlobalError) {
            AlertService.showToast('Form contain errors, please check once', 'error');
        }
    }

});

const openDialog = (component: any) => {
    return new Promise((resolve, reject) => {
        Communications.DialogStateSubject.next({component, promise: {resolve, reject}})
    });
}

const getCancelToken = (): CancelTokenSource => {
    return axios.CancelToken.source();
}

const getPayloadFilterDates = (mode: 'day' | 'week' | 'month' | 'year'): { start_date: string, end_date: string } => {
    const payload = {start_date: '', end_date: moment().endOf('day').format('YYYY-MM-DD')}
    switch (mode) {
        case "day":
            payload.start_date = moment().startOf('day').format('YYYY-MM-DD')
            break;
        case "week":
            payload.start_date = moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD')
            break;
        case "month":
            payload.start_date = moment().subtract(1, "month").startOf('day').format('YYYY-MM-DD')
            break;
        case "year":
            payload.start_date = moment().subtract(1, "year").startOf('day').format('YYYY-MM-DD')
            break;
    }
    return payload;
}

const transformTimeStamp = (date: Date | string | undefined, showTime = true) => {
    return moment(date).format(showTime ? 'DD-MMM-YYYY | hh:mm A' : 'DD-MMM-YYYY');
}

const convertDateFormat = (date: Date, format: string = 'YYYY-MM-DD') => {
    if (!date) {
        return
    } else {
        return moment(date).format(format)
    }
}

const generateInterventionNameFromMedicalRecord = (medicalRecordDetails: any) => {
    return `${medicalRecordDetails?.injury_details?.map((bodyPart: any, index: number) => {
        return (bodyPart?.body_part_details?.name + (index === medicalRecordDetails?.injury_details?.length - 1 ? '' : '/'))
    })} - ${CommonService.transformTimeStamp(medicalRecordDetails?.created_at)}`
}

const getTheDifferenceBetweenDates = (fromDate: string) => {
    let a = moment();
    let b = moment(moment(fromDate), 'YYYY');
    let diff = a.diff(b, 'years')
    return diff;
}
const getFirstLetterOfEachWord = (name: string) => {

    let names = name?.split(" ");
    let firstLetters = "";
    for (let i = 0; i < names?.length; i++) {
        firstLetters += names[i][0];
    }
    return firstLetters?.toUpperCase();
}


const getFlatJsonFromNestedJSON = (jsonData: any, rootName: string = "", ignoreList: any[] = []): any => {

    const appendFormData = (data: any, root: any) => {
        let newObj: any = {};
        let tmp: any = {};
        if (!ignore(root)) {
            console.log(data, root);
            root = root || '';
            if (data instanceof File) {
                console.log(root, data, 'appending');
                newObj[root] = data;
            } else if (Array.isArray(data)) {
                for (let i = 0; i < data.length; i++) {
                    tmp = appendFormData(data[i], root + '[' + i + ']');
                    newObj = {...newObj, ...tmp}
                }
            } else if (typeof data === 'object' && data) {
                for (let key in data) {
                    if (data.hasOwnProperty(key)) {
                        if (root === '') {
                            tmp = appendFormData(data[key], key);
                            newObj = {...newObj, ...tmp}
                        } else {
                            tmp = appendFormData(data[key], root + '.' + key);
                            newObj = {...newObj, ...tmp}
                        }
                    }
                }
            } else {
                if (data !== null && typeof data !== 'undefined') {
                    newObj[root] = data;
                    console.log(root, data, newObj, 'appending');
                }
            }
        }
        return newObj;
    }

    const ignore = (root: any) => {
        return Array.isArray(ignoreList)
            && ignoreList.some((x) => {
                return x === root;
            });
    }

    return appendFormData(jsonData, rootName);
};

const getFormDataFromJSON = (obj: any, rootName = '', ignoreList = []): FormData => {

    const formData = new FormData();

    const appendFormData = (data: any, root: any) => {
        if (!ignore(root)) {
            root = root || '';
            if (data instanceof File) {
                formData.append(root, data);
            } else if (Array.isArray(data)) {
                for (let i = 0; i < data.length; i++) {
                    appendFormData(data[i], root + '[' + i + ']');
                }
            } else if (typeof data === 'object' && data) {
                for (let key in data) {
                    if (data.hasOwnProperty(key)) {
                        if (root === '') {
                            appendFormData(data[key], key);
                        } else {
                            appendFormData(data[key], root + '.' + key);
                        }
                    }
                }
            } else {
                if (data !== null && typeof data !== 'undefined') {
                    formData.append(root, data);
                }
            }
        }
    }

    const ignore = (root: any) => {
        return Array.isArray(ignoreList)
            && ignoreList.some((x: any) => {
                return x === root;
            });
    }

    appendFormData(obj, rootName);

    return formData;
}

const capitalizeFirstLetter = (string: string) => {
    if (string === null || string === undefined) {
        return string;
    }
    const words = string.split('_');
    const capitalizedWords = words.map(word => {
        if (word.length === 0) {
            return word;  // Handle multiple underscores in a row
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });

    return capitalizedWords.join(' ');
}

const kFormatter = (num: any) => {
    // @ts-ignore
    return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num)
}

const getLettersFromNumber = (number: number) => {
    const previousLetters: any = (number >= 26 ? getLettersFromNumber(Math.floor(number / 26) - 1) : '');
    const lastLetter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[number % 26];
    return previousLetters + lastLetter;
}

const getRandomNumberBetweenRange = (startingNumber: number, endingNumber: number) => {
    startingNumber = Math.ceil(startingNumber);
    endingNumber = Math.floor(endingNumber);
    return Math.floor(Math.random() * (endingNumber - startingNumber + 1)) + startingNumber;
}

const getMinsAndSecondsFromSeconds = (numberOfSeconds: number) => {
    const minutes = Math.floor(numberOfSeconds / 60);
    const seconds = (numberOfSeconds % 60);
    return {
        minutes: minutes < 10 ? '0' + minutes : minutes,
        seconds: seconds < 10 ? '0' + seconds : seconds
    }
}

const getHoursAndMinutesFromMinutes = (minutes: number) => {
    return moment().startOf('day').add(minutes, 'minutes').format('hh:mm A');
}

const downloadFile = (url: string, fileName: any, type = 'pdf') => {
    switch (type) {
        case 'image':
            axios.get(url, {
                headers: {'Content-Type': 'image/*'}
            }).then(
                (data: any) => {
                    const blob = new Blob([data], {
                        type: 'image/*' // must match the Accept type
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                }, (error) => {
                    console.log('error')
                });
            break;

        case 'pdf':
            axios.get(url, {
                headers: {Accept: 'application/pdf'},
                responseType: 'blob'
            }).then(
                (response) => {
                    const blob = new Blob([response.data], {
                        type: 'application/pdf'
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                },
                (error) => {
                    console.log('Error downloading PDF:', error);
                }
            );
            break;
        case 'csv':
            axios.get(url, {
                headers: {Accept: 'application/csv'}, responseType: 'blob'
            }).then(
                (response: any) => {
                    const blob = new Blob([response.data], {
                        type: "application/octet-stream" // or Content-type: "application/vnd.ms-excel"
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                }, (error) => {
                    console.log('error')
                });
            break;
        case 'xlsx':
            axios.get(url, {
                headers: {Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
                responseType: 'blob'
            }).then(
                (response: any) => {
                    const blob = new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                }, (error) => {
                    console.log('error')
                });
            break;
        default:
            console.log(type, ' file download not supported');
    }
}

const generateBlobFileFromUrl = (attachmentUrl: string, attachmentTitle: string, attachmentType: string) => {
    return fetch(attachmentUrl)
        .then((res) => res.blob())
        .then((myBlob) => {
            console.log(myBlob);
            const myFile = new File([myBlob], attachmentTitle, {
                type: attachmentType
            });
            return myFile;
        });
};

const getFlatQuestionList = (stepData: any): any => {
    const flatQuestionList: any = [];
    const questionListParser = (arrayData: []) => {
        arrayData.forEach((option: any, index, array) => {
            if (option?.questions) {
                option?.questions.forEach((question: any) => {
                    flatQuestionList.push(question);
                    if (question?.options) {
                        questionListParser(question?.options);
                    }
                })
            }
        })
    }
    if (stepData?.questions) {
        stepData?.questions.forEach((value: any) => {
            flatQuestionList.push(value);
            if (value?.options) {
                questionListParser(value?.options);
            }
        })
    }
    return flatQuestionList;

};

const truncateName = (data: any, limit = 20) => {
    // Helper function to truncate strings
    const truncate = (name: any) => {
        return name.length <= limit ? name : name.substring(0, limit) + '...';
    }

    // Check if the input is an object with a 'name' key
    if (typeof data === 'object' && data !== null && 'name' in data) {
        data.name = truncate(data.name);
        return data;
    }
    // Check if the input is a string
    else if (typeof data === 'string') {
        return truncate(data);
    } else {
        throw new Error("Input should be an object with a 'name' key or a string.");
    }
}

const getArrayOfValuesOfOneKeyFromJSON = (array: any[], key: string) => {
    if (array && array.length > 0) {
        const arrayWithDesiredKeyValue = array.map((item) => {
            return item[key];
        });
        return arrayWithDesiredKeyValue;
    } else {
        return [];
    }
}

const convertDateFormat2 = (date: Date, format: string = 'DD-MMM-YYYY') => {
    return moment(date).format(format);
}


const generateUseCaseFromCaseDetails = (case_details: any) => {
    return `${CommonService.convertDateFormat2(case_details?.case_date)} - ${case_details?.injury_details?.map((bodyPart: any, index: number) => {
        return (bodyPart?.body_part_details + (bodyPart?.body_side ? `( ${bodyPart.body_side} )` : ' ') + (index !== case_details?.injury_details?.length - 1 ? ' | ' : ''))
    })} `
}

const generateUseCaseFromCaseDetails2 = (case_details: any) => {
    return `${CommonService.convertDateFormat2(case_details?.created_at)} - ${case_details?.injury_details?.map((bodyPart: any, index: number) => {
        return (bodyPart?.body_part_name + (bodyPart?.body_side ? `( ${bodyPart.body_side} )` : ' ') + (index !== case_details?.injury_details?.length - 1 ? ' | ' : ''))
    })} `
}

const onConfirm = (config: IConfirmationConfig = {}) => {
    return new Promise((resolve, reject) => {
        Communications.ConfirmStateSubject.next({config, promise: {resolve, reject}})
    });
}

const Capitalize = (str: string) => {
    const capitalize = (str: string) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return str.split(' ').map(capitalize).join(' ');
}

const capitalizeFirstLetterOfEachWord = (string: string) => {
    return string?.split(' ').map((word: string) => capitalizeFirstLetter(word)).join(' ');
}
const getObjectKeyValue = (object: any, key: string) => {
    return _.get(object, key);
}

const getSystemFormatTimeStamp = (date: Date | string, showTime: boolean = false) => {
    if (!date) {
        return "N/A"
    }
    if (showTime) {
        return moment(date).format('DD-MMM-YYYY hh:mm A');
    } else {
        return moment(date).format('DD-MMM-YYYY');
    }
};

const capitalizeFirstLetterAndRemoveUnderScore = (string: string | undefined) => {
    if (!string) return '';
    return string.split('_').map((word: string) => capitalizeFirstLetter(word)).join(' ');
}

const removeKeysFromJSON = (obj: any, keys: string[]): any => {
    for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            switch (typeof (obj[prop])) {
                case 'object':
                    if (keys.indexOf(prop) > -1) {
                        delete obj[prop];
                    } else {
                        removeKeysFromJSON(obj[prop], keys);
                    }
                    break;
                default:
                    if (keys.indexOf(prop) > -1) {
                        delete obj[prop];
                    }
                    break;
            }
        }
    }
    return obj;
}

const isEqual = (a: any, b: any) => {
    console.log(a, b);
    return _.isEqual(a, b);
}

const formatPhoneNumber = (phone: string) => {
    const x = phone?.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    if (x) {
        phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }
    return phone
}

const extractName = (data: any) => {
    return (data?.first_name || data?.last_name ? data?.last_name + ' ' + data?.first_name : '-');
};

const getNormalizedFileType = (fileType: any) => {
    let type: any = fileType;
    if (type.includes('image')) {
        type = "image";
    } else if (type.includes('pdf')) {
        type = "pdf";
    } else if (type.includes('word')) {
        type = "word";
    } else if (type.includes('spreadsheet')) {
        type = "xls";
    } else if (type.includes('video')) {
        type = "video";
    } else {
        type = "application";
    }
    return type;
}

const printAttachment = (attachment: IAttachment) => {
    let type: any = getNormalizedFileType(attachment?.type);
    printJS({
        printable: attachment.url,
        type: type
    });
}

const openLinkInNewTab = (url: string) => {
    window.open(url, '_blank');
}

const isTextEllipsisActive = (e: HTMLDivElement) => {
    return (e.offsetWidth < e.scrollWidth);
}

const scrollToErrorField = (formRef: any, index?: number) => {
    if (!index) index = 0;
    const firstErrorField = Object.keys(formRef.current.errors)[0];
    console.log("sadas", firstErrorField);
    if (firstErrorField) {
        const errorFieldRef = document.getElementsByName(firstErrorField)[index];
        if (errorFieldRef) {
            errorFieldRef.scrollIntoView({behavior: 'smooth'});
            errorFieldRef.focus();
        }
    }
};

const setQueryParam = (key: string, value: string, announce: boolean = true) => {
    const existingUrl = new URL(window.location.href);
    let existingUrlString = existingUrl.toString();
    let updatedURL = '';
    const re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
    if (value === undefined) {
        if (existingUrlString.match(re)) {
            updatedURL = existingUrlString.replace(re, '$1$2').replace(/[?&]$/, '').replaceAll(/([?&])&+/g, '$1').replace(/[?&]#/, '#');
        } else {
            updatedURL = existingUrlString;
        }
    } else {
        if (existingUrlString.match(re)) {
            updatedURL = existingUrlString.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            let hash = '';
            if (existingUrlString.indexOf('#') !== -1) {
                hash = existingUrlString.replace(/.*#/, '#');
                existingUrlString = existingUrlString.replace(/#.*/, '');
            }
            const separator = existingUrlString.indexOf('?') !== -1 ? "&" : "?";
            updatedURL = existingUrlString + separator + key + "=" + value + hash;
        }
    }
    window.history.pushState({}, '', updatedURL);
}

const removeQueryParam = (key: string, announce: boolean = true) => {
    const existingUrl = new URL(window.location.href);
    existingUrl.searchParams.delete(key);
    const url = existingUrl.toString();
    window.history.pushState({}, '', url);
}

const ComingSoon = () => {
    AlertService.showToast("Coming Soon", 'info');
}

const getSuperscriptForDate = (date: Moment) => {
    const day = date.format('D');
    if (day.endsWith('1') && !day.endsWith('11')) {
        return 'st';
    } else if (day.endsWith('2') && !day.endsWith('12')) {
        return 'nd';
    } else if (day.endsWith('3') && !day.endsWith('13')) {
        return 'rd';
    } else {
        return 'th';
    }
};

const nameToInitials = (fullName: string) => {
    const namesArray = fullName.trim().split(' ');
    if (namesArray.length === 1) {
        return namesArray[0].charAt(0)
    } else {
        return Capitalize(namesArray[0].charAt(0) + namesArray[namesArray.length - 1].charAt(0));
    }
}

const calculateFinalAmountFromDiscountPercentage = (percentage: any, totalAmount: number) => {
    return (parseFloat(percentage) / 100) * totalAmount;
}


const breakupTimeSlots = (time: any, duration: number) => {
    const totalMinutes = time.start_time;
    let timeInMinutes = time.start_time;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    let startTime = moment(hours + ':' + minutes, "hh:mm");
    let endTime = startTime.clone().add(time.end_time - time.start_time, 'minutes');
    let allTimes = [];
    while (startTime < endTime) {
        //Push times
        const slotStart = startTime.format("hh:mm a");
        startTime.add(duration, 'minutes');
        allTimes.push({
            start: slotStart,
            start_min: timeInMinutes,
            end_min: timeInMinutes + duration,
            end: startTime.format("hh:mm a")
        });
        timeInMinutes = timeInMinutes + duration;
    }
    // console.log(time, allTimes, duration);
    return allTimes;
}

const generateTimeSlots = (times: any[], duration = undefined) => {
    if (duration) {
        const slots: any[] = [];
        times.forEach(value => {
            const slot = breakupTimeSlots(value, parseInt(duration || ''));
            slots.push(...slot);
        })
        return slots;
    }
}

const getDateFromTimezone = (utcTimestamp: any, timezone: any, format?: string) => {
    const localTime = momentTimezone.utc(utcTimestamp).tz(timezone);
    return localTime.format(format);
}

const convertToDecimals = (value: number | string): string => {
    if (value === null || value === undefined || isNaN(Number(value))) {
        return "0.00"; // Return "0.00" for invalid values
    }

    const numValue = Number(value); // Convert to number safely
    return numValue.toFixed(2); // Always return as a string with 2 decimals
};


const formatAddressBillAppointment = (address: any) => {
    const {
        address_line = "",
        city = "",
        state = "",
        zip_code = "",
    } = address || {};

    // Format state and zip code together if both exist
    const stateZip = [state, zip_code].filter(Boolean).join(" ");

    // Construct the full address
    const addressParts = [address_line, city, stateZip].filter(Boolean); // Remove empty values

    return addressParts.join(", ");
};


const getFirstLetterCapitalized = (text: string): string => {
    if (!text) return "";
    return text.charAt(0).toUpperCase();
};

const formatDateInDayAlphabet = (dateStr: any) => {
    const date = new Date(dateStr);

    // Get day, month, and year
    const day = date?.getDate();
    const month = date?.toLocaleString('en-US', {month: 'short'});
    const year = date?.getFullYear();
    const weekday = date?.toLocaleString('en-US', {weekday: 'short'});

    // Function to get ordinal suffix
    const getOrdinalSuffix = (day: any) => {
        if (day > 3 && day < 21) return "th";
        switch (day % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    };

    return `${weekday}, ${day}${getOrdinalSuffix(day)} ${month} ${year}`;
}

const convertDateToLocalTimeZone = (appointmentDate: any, startTimeInMinutes: any, userTimeZone: any) => {
    const hours = Math.floor(startTimeInMinutes / 60);
    const minutes = startTimeInMinutes % 60;
    const localDateTime = moment.tz(`${appointmentDate} ${hours}:${minutes}`, 'YYYY-MM-DD HH:mm', userTimeZone);
    const utcDateTimeISO = localDateTime.utc().toISOString();
    return utcDateTimeISO;
}

const calculateDiscountedAmount = (total: number, discountPercent: number, maxDiscount: number): number => {
    // Calculate discount based on percentage
    const discount = (total * discountPercent) / 100;

    // Apply max discount limit
    return Math.min(discount, maxDiscount);
};

const FirstLetterCapitalizeWord = (word: string): string => {
    if (!word) return "";
    return word.charAt(0).toUpperCase();
};


const CommonService = {
    CurrentDate,
    parseQueryString,
    handleErrors,
    openDialog,
    onConfirm,
    formatSizeUnits,
    getRandomID,
    getBytesInMB,
    getCancelToken,
    getPayloadFilterDates,
    getFormDataFromJSON,
    capitalizeFirstLetter,
    kFormatter,
    getUUID,
    getLettersFromNumber,
    getRandomNumberBetweenRange,
    getMinsAndSecondsFromSeconds,
    convertDateFormat,
    downloadFile,
    generateBlobFileFromUrl,
    getFlatJsonFromNestedJSON,
    getFlatQuestionList,
    getArrayOfValuesOfOneKeyFromJSON,
    Capitalize,
    getObjectKeyValue,
    getHoursAndMinutesFromMinutes,
    getSystemFormatTimeStamp,
    transformTimeStamp,
    getTheDifferenceBetweenDates,
    removeKeysFromJSON,
    isEqual,
    formatPhoneNumber,
    generateInterventionNameFromMedicalRecord,
    extractName,
    printAttachment,
    getNormalizedFileType,
    openLinkInNewTab,
    isTextEllipsisActive,
    setQueryParam,
    removeQueryParam,
    ComingSoon,
    convertDateFormat2,
    generateUseCaseFromCaseDetails,
    getSuperscriptForDate,
    nameToInitials,
    calculateFinalAmountFromDiscountPercentage,
    generateTimeSlots,
    scrollToErrorField,
    convertToDecimals,
    capitalizeFirstLetterOfEachWord,
    generateUseCaseFromCaseDetails2,
    capitalizeFirstLetterAndRemoveUnderScore,
    getFirstLetterOfEachWord,
    formatAddressBillAppointment,
    getDateFromTimezone,
    truncateName,
    getFirstLetterCapitalized,
    formatDateInDayAlphabet,
    convertDateToLocalTimeZone,
    calculateDiscountedAmount,
    FirstLetterCapitalizeWord,
    // createValidationsObject,
    // createYupSchema,

    _api: ApiService,
    _communications: Communications,
    _routeConfig: RouteConfigService,
    _alert: AlertService,
    _localStorage: LocalStorageService,
    _account: AccountService,
    _user: UserService,
    _staticData: StaticDataService,
    _appointment: AppointmentService,
    _client: ClientService,
    _transaction: TransactionService,
    _bookAppointment: BookAppointmentService,
    _cases: CasesService,
    _dashboard: DashboardService,
}
export default CommonService;
